export default __webpack_public_path__ + "static/media/FactoryIconWhite.b51f968c.svg";